import React, { useEffect, useImperativeHandle } from 'react'

import { IActionComponentAPI, IActionComponentProps, IActionSubmitResponse } from '../types'
import { SURVEY_FEEDBACK_DONE_EVENT } from '../../modules/hooks/events'
import useSession from '../../session/useSession'

// ExitAction — triggered when backend returns {action: 'exit'}.
// Disables navigation and signals PV that the exit flow resolved (PV tears the session down).
// Dispatched unconditionally — also when the backend skipped the feedback form.
const ExitAction = React.memo(
  React.forwardRef<IActionComponentAPI, IActionComponentProps>((_props, ref) => {
    const session = useSession()

    useEffect(() => {
      session.enableNavigation(false)
      window.dispatchEvent(new CustomEvent(SURVEY_FEEDBACK_DONE_EVENT))
    }, [session])

    useImperativeHandle<IActionComponentAPI, IActionComponentAPI>(
      ref,
      () => ({
        tryNext: () => true,
        tryPrev: () => false,
        showValidation() {},
        get submitResponse(): IActionSubmitResponse[] {
          return []
        },
        get currentQuestionModel(): null {
          return null
        }
      }),
      []
    )

    return null
  })
)

ExitAction.displayName = 'ExitAction'

export default ExitAction
